/*
 * newsbot - forked from autobrr
 */

import { useEffect } from "react";
import { RouterProvider } from "@tanstack/react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@components/hot-toast";
import { router } from "./router";
import { queryClient } from "@api/QueryClient";
import { Portal } from "@components/portal";
import { AuthProvider } from "@contexts/AuthContext";

export function App() {
  useEffect(() => {
    const themeMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    const handleThemeChange = (e: MediaQueryListEvent | MediaQueryList) => {
      if (e.matches) {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    };

    handleThemeChange(themeMediaQuery);
    themeMediaQuery.addEventListener("change", handleThemeChange);
    return () => themeMediaQuery.removeEventListener("change", handleThemeChange);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Portal>
          <Toaster position="top-right" />
        </Portal>
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  );
}
